// extracted by mini-css-extract-plugin
export default {"card":"style_card__Joz52","title":"style_title__8C2ZS","image":"style_image__MZtG3"};